import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { ICategory } from "../shared/models/categories.model";
import { ClientData } from "./client";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";
import { Utilities } from "./utilities";
import * as firebase from "firebase";

@Injectable()
export class CouponsData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private tracking: TrackingProvider,
    private utilities: Utilities,
    private clientData: ClientData,
  ) { }

  public getCouponsByClient(client: string): Observable<ICategory[]> {
    return this.afDb.list<ICategory>(`Clients/${client}/Coupons`).
      valueChanges();
  }

  public getCouponsByCode(clientId: string, code: string): Promise<ICategory[]> {
    return this.afDb.database.ref(`Clients/${clientId}/Coupons`)
      .orderByChild("code")
      .equalTo(code)
      .once("value")
      .then((snap) => snap.val());
  }

  public createCoupon(client: string, coupon: any) {
    if (!coupon.id) {
      this.action = "create";
      coupon.id = this.afDb.createPushId();
    } else {
      this.action = "update";
    }
    if (!coupon.code) { coupon.code = this.utilities.generateID(false, 5); }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Coupons/${coupon.id}`)
        .update(coupon)
        .then(() => {
          return this.historyData.set(
            `Coupon content`,
            "coupons",
            this.action,
            coupon,
          );
        })
        .then(() => {
          if (coupon.privacy === "public") {
            this.clientData.getClientConfig(client).once("value").then(() => {
              this.tracking.trackEntity(_TRACKING_ENTITIES.COUPONS, coupon.id, client, coupon);
            });
          }
          resolve(coupon);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public updateReferred(client: string, referredData: any) {
    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Referred`)
        .update(referredData)
        .then(() => {
          this.historyData.set(
            `Referred content`,
            "referred",
            "update",
            referredData,
          );
          resolve(referredData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public sharedCoupon(client: string, coupon: any, userId: string) {
    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Coupons/${coupon.id}/quota`)
        .once("value")
        .then((r) => {
          const quota = r.val();
          if (quota > 0) {
            return this.afDb.database.ref(`Clients/${client}/UserCoupons/${userId}/${coupon.id}`)
              .once("value")
              .then(async (result) => {
                if (!result.val()) {
                  return await this.afDb.database.ref(`Clients/${client}/UserCoupons/${userId}/${coupon.id}`)
                    .update({ ...coupon, assigned_at: firebase.database.ServerValue.TIMESTAMP })
                    .then(async () => await this.afDb.database.ref(`Clients/${client}/Coupons/${coupon.id}/quota`)
                      .transaction((value) => value > 0 ? value -= 1 : 0))
                    .then(() => resolve(true))
                    .catch((error) => {
                      reject(error);
                    });
                } else {
                  return resolve(false);
                }
              });
          } else {
            return resolve(-1);
          }
        });
    });
  }

  public getClientCouponsById(clientId: string, couponId: string): Observable<ICategory> {
    return this.afDb.object<ICategory>(`Clients/${clientId}/Coupons/${couponId}`).valueChanges();
  }

  public getReferralCouponRef(clientId: string) {
    // console.log("id client", clientId);
    return this.afDb.object(`/Clients/${clientId}/Referred`)
      .query.ref;
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/coupons.ts